import { useAccount } from '@air/utils-auth';

import { useCanMountPrivateOnboardingIntro } from '~/components/v2/components/workspace/onboarding-intro/hooks/useCanMountPrivateOnboardingIntro';
import {
  getWorkspaceAgentOnboardingReviewTaskVisibility,
  type WorkspaceAgentOnboardingReviewTaskVisibility,
} from '~/components/v2/store/features/onboarding/slices/createWorkspaceAgentIntroSlice';
import { useOnboardingPreferencesStore } from '~/components/v2/store/features/onboarding/useOnboardingPreferencesStore';

export const usePrivateWorkspaceAgentOnboardingReviewTaskVisibility = (): {
  onboardingReviewTaskVisibility: WorkspaceAgentOnboardingReviewTaskVisibility;
} => {
  const { data: account } = useAccount();
  const { canMountPrivateOnboardingIntro } = useCanMountPrivateOnboardingIntro();
  const workspaceAgentIntro = useOnboardingPreferencesStore((state) => state.workspaceAgentIntro);

  if (!canMountPrivateOnboardingIntro) {
    return { onboardingReviewTaskVisibility: 'hidden' };
  }

  return {
    onboardingReviewTaskVisibility: getWorkspaceAgentOnboardingReviewTaskVisibility(workspaceAgentIntro, account?.id),
  };
};
